import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/shared/libs/queryClient";
import { searchCollectionSizes } from "@/api/collectionSizes";
import type { CollectionsSizeSearchParams } from "@/types/collection-types";

/**
 * 수집 데이터 크기 검색 Query Hook
 */
export function useCollectionSizesQuery(
  params: CollectionsSizeSearchParams,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: queryKeys.collectionSizes.search(params as unknown as Record<string, unknown>),
    queryFn: () => searchCollectionSizes(params),
    enabled: enabled && !!params.start_date && !!params.end_date,
    placeholderData: (prev) => prev,
  });
}
